import { studyGroupsApi } from "@/lib/humhub-api/studyGroups";

export const createStudyGroupQuery = (id: string | number | null) => ({
  queryKey: ["studyGroup", id],
  queryFn: () => {
    if (id === null || id === undefined) {
      throw new Error("Study group ID is required");
    }
    return studyGroupsApi.getStudyGroupInfo(id);
  },
  staleTime: 5 * 60 * 1000,
  enabled: Boolean(id),
});
